module.exports = __webpack_public_path__ + "img/colazione_1.jpeg.old.7ff814a5.jpeg";